export default __webpack_public_path__ + "static/media/SeaStars_05.e15f49b1.png";